<template>
  <div class="products-page">
    <div
      v-if="gettingData"
      class="d-flex flex-column align-items-center mt-8 py-6"
    >
      <spring-spinner
        :animation-duration="1500"
        :size="60"
        color="#bf0000"
        class="mx-auto"
      />
      <p class="primary--text mx-auto font-weight-bold mt-6">
        در حال بارگذاری...
      </p>
    </div>
    <v-card v-else class="main-card">
      <v-row class="mt-1 mb-8 ms-2 me-2">
        <v-col md="6" cols="12" class="d-flex align-center">
          <span class="fs-xxlarge pb-4 pb-lg-0">محصولات</span>
        </v-col>
        <v-col md="6" cols="12">
          <v-text-field
            placeholder="جستجو در عنوان محصولات..."
            outlined
            prepend-inner-icon="mdi-magnify"
            hide-details
            class="ms-md-3"
            v-model="productSearch"
          >
            <template v-slot:append>
              <v-icon
                small
                v-if="productSearch"
                class="mt-1"
                @click="productSearch = ''"
                >mdi-close</v-icon
              >
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <div v-if="!computedProducts.length" class="grey--text text-center py-15">
        محصولی برای نمایش وجود ندارد.
      </div>
      <v-row v-else>
        <v-col
          md="3"
          sm="6"
          cols="12"
          v-for="(product, index) in computedProducts"
          :key="index"
        >
          <div class="product-box">
            <div class="product-image">
              <img
                :src="product.pictureUrl ? product.pictureUrl : '/no-image.png'"
              />

              <v-btn
                color="warning"
                class="add-button"
                @click="addProduct(product)"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
            <div class="mt-1">
              <b class="product-title grey--text text--darken-2">
                {{ product.name }}
              </b>
            </div>
            <div class="mt-6 text-left">
              <span class="warning--text text--darken-1 fs-xlarge">
                {{ Number(product.price).toLocaleString() }} تومان
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Dialog for purchase confirmation -->
    <v-dialog v-model="purchaseDialog" width="600">
      <v-card class="modal-card">
        <v-card-title class="py-0">
          <div class="text-right fs-xlarge grey--text text--darken-3">
            سفارش محصول <b>{{ selected.title }}</b>
          </div>
        </v-card-title>
        <v-card-text class="pb-2">
          <v-divider class="my-4"></v-divider>
          <div class="text-right">
            <b class="grey--text text--darken-4 fs-medium">
              آیا از سفارش این محصول اطمینان دارید؟
            </b>
            <p class="grey--text text--darken-2 mt-2">
              در صورت تایید، درخواست شما به تیم پشتیبانی و فروش ارسال میشود و
              همکاران ما جهت تعیین نحوه پرداخت و خرید محصول با شما تماس خواهند
              گرفت.
            </p>
          </div>

          <div class="text-left pt-4">
            <v-btn
              width="80"
              height="42"
              class="rounded-lg teal me-3 white--text"
              @click="confirmPurchase()"
              :loading="loading"
              ><v-icon small class="me-2">mdi-check-underline</v-icon>بله</v-btn
            >
            <v-btn
              width="80"
              height="42"
              class="rounded-lg error"
              @click="purchaseDialog = false"
              ><v-icon small class="me-2">mdi-close</v-icon>خیر</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SpringSpinner } from "epic-spinners";
export default {
  name: "Products",

  components: {
    SpringSpinner,
  },

  data() {
    return {
      products: [],
      selected: {},
      productSearch: "",
      purchaseDialog: false,
      gettingData: false,
      loading: false,
    };
  },

  mounted() {
    this.getProducts();
  },

  methods: {
    getProducts() {
      this.gettingData = true;
      this.$http
        .get(this.baseUrl + "/products/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })

        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.gettingData = false;
          }
        })
        .catch((err) => {
          this.gettingData = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
    addProduct(item) {
      this.selected = item;
      this.purchaseDialog = true;
    },
    confirmPurchase() {
      this.loading = true;
      this.$http
        .post(
          this.baseUrl + "/invoice/new",
          {
            productId: this.selected.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )

        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            this.purchaseDialog = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.purchaseDialog = false;
          this.loading = false;
        });
    },
  },

  computed: {
    computedProducts() {
      let filtered = this.products.filter((x) =>
        x.name.includes(this.productSearch)
      );
      return filtered;
    },
  },
};
</script>

<style lang="scss">
.products-page {
  .product {
    &-box {
      background-color: #f0f0f0;
      width: 90%;
      border-radius: 12px;
      margin: 0 auto 25px;
      padding: 15px;
      box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px,
        rgba(0, 0, 0, 0.24) 0px 1px 2px !important;

      &:hover {
        img {
          transform: scale(1.05);
        }
      }
    }

    &-image {
      width: 100%;
      aspect-ratio: 1 / 1;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        transition: 0.6s all;
        transform: scale(1);
      }

      .add-button {
        min-width: 40px;
        width: 40px;
        height: 40px;
        border-radius: 10px !important;
        position: absolute;
        bottom: -7px;
        left: -7px;
        box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px,
          rgba(0, 0, 0, 0.24) 0px 1px 2px !important;
      }
    }

    &-title {
      font-size: 1.08rem;
    }
  }
}
</style>
